const en = require('./en.json')
const es = require('./es.json')

const translations = { en, es }

export default translations
